import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap } from 'lucide-react';
const education = [{
  degree: 'M.S., Real Estate Finance',
  institution: 'New York University',
  year: '2001',
  logo: 'https://www.google.com/s2/favicons?domain=nyu.edu&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/nyu.edu'
}, {
  degree: 'Professional Education Coursework, Finance & Controls, Managerial Finance',
  institution: 'New York University',
  year: '1999',
  logo: 'https://www.google.com/s2/favicons?domain=nyu.edu&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/nyu.edu'
}, {
  degree: 'B.S., Environmental Science & Business (Double Major)',
  institution: 'University of Michigan',
  year: '1997',
  logo: 'https://www.google.com/s2/favicons?domain=umich.edu&sz=128',
  fallbackLogo: 'https://logo.clearbit.com/umich.edu'
}];
export function Education() {
  return <section className="py-20 bg-corporate-gray" data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-115">
          <h2 className="text-2xl md:text-3xl font-bold text-corporate-blue mb-4" data-id="element-116">
            Education
          </h2>
          <div className="w-20 h-1 bg-corporate-teal rounded-full" data-id="element-117"></div>
        </motion.div>

        <div className="space-y-6 max-w-3xl" data-id="element-118">
          {education.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-[#FDFBF7] p-6 rounded-lg shadow-sm border-l-4 border-corporate-teal flex items-start gap-5" data-id="element-119">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5 bg-white border border-[#E8E0D0] overflow-hidden p-1.5" data-id="element-120">
                <img src={item.logo} alt={`${item.institution} logo`} className="w-full h-full object-contain" onError={e => {
              const target = e.target as HTMLImageElement;
              if (item.fallbackLogo && target.src !== item.fallbackLogo) {
                target.src = item.fallbackLogo;
              } else {
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.classList.add('bg-corporate-teal/10');
                  parent.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-corporate-teal"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>';
                }
              }
            }} data-id="element-121" />
              </div>
              <div className="flex-1" data-id="element-122">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1" data-id="element-123">
                  <h3 className="text-base font-bold text-corporate-blue leading-snug" data-id="element-124">
                    {item.degree}
                  </h3>
                  <span className="text-sm text-[#9A9184] font-medium bg-[#F0EBE1] px-3 py-1 rounded-full flex-shrink-0" data-id="element-125">
                    {item.year}
                  </span>
                </div>
                <p className="text-corporate-teal font-medium text-sm mt-1" data-id="element-126">
                  {item.institution}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}